export default __webpack_public_path__ + "static/O0252-d8fddf3d19a8105c57f14a01ce210bbc.png";